module.exports = __webpack_public_path__ + "img/Klizer_White_JustName.8cf360e6.png";